<div class="page-container" [class.loading]="isLoading">
    <app-header [back]="true" [backRoute]="'..'" title="{{ 'settings.role-update.header' | translate }}" />

    <app-steps
        #appSteps
        [steps]="[moduleStep, permissionStep]"
        (onPrimary)="onSave()"
        [options]="{
            allowNavigationIfFormIsInvalid: role.isImmutable,
            allowCompletionIfFormIsInvalid: role.isImmutable,
        }"
    >
        <app-step
            #moduleStep
            [stepForm]="moduleForm"
            step="{{ 'settings.role-update.moduleAccessStepLabel' | translate }}"
            title="{{ 'settings.role-update.moduleAccessStepTitle' | translate }}"
        >
            <app-form-role-modules
                #moduleForm
                [role]="role"
                [profilePermissions]="profilePermissions"
                [moduleFeaturePermissions]="moduleFeaturePermissions"
                [(assignableRoles)]="assignableRoles"
            ></app-form-role-modules>
        </app-step>

        <app-step
            #permissionStep
            [stepForm]="permissionForm"
            step="{{ 'settings.role-update.permissionLevelStepLabel' | translate }}"
            title="{{ 'settings.role-update.permissionLevelStepTitle' | translate }}"
        >
            <app-form-role-permissions
                #permissionForm
                [role]="role"
                [profilePermissions]="profilePermissions"
                [(employeeAccessLevel)]="employeeAccessLevel"
            ></app-form-role-permissions>
        </app-step>
    </app-steps>
</div>
